import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '../base/_base-http.service';
import { Config } from '../config/env.config';
import {catchError} from 'rxjs/operators';


@Injectable()
export class VersionsService extends BaseHttpService {

  getVersions(): Observable<any> {
    return this.http.get(Config.API + '/versions')

        .pipe(catchError(this.handleError.bind(this)));
  }
}
